import React from 'react';
import get from 'lodash/get';
import Button from '@material-ui/core/Button';
import BuildIcon from '@material-ui/icons/Build';

const stopPropagation = (e) => e.stopPropagation();

const QuoteButton = ({ record, source, fromQuote = false }) => {
  if (get(record, source)) {
    const queryParam = fromQuote ? 'quote_id' : 'request_id';
    const url = `/#/quote-builder/?${queryParam}=${get(record, source)}`;
    return (
      <>
        <Button
          variant="contained"
          color="default"
          onClick={stopPropagation}
          href={url}
          startIcon={<BuildIcon />}
        >
          Build Quote
        </Button>
      </>
    );
  }
  return null;
};

QuoteButton.defaultProps = {
  addLabel: true,
};

export default QuoteButton;
